import { reduxActionTypes, ReduxAction, State } from '.';

const initialState: State = {
    files: [],
    loading: false,
    processingAction: false,
    savedFiles: true
};

export default function (state: State = initialState, action: ReduxAction) {
    switch (action.type) {
        // Get files
        case reduxActionTypes.GET_FILES_BY_SOURCE_PROCESSING:
            return {
                ...state,
                loading: true,
            };

        case reduxActionTypes.GET_FILES_BY_SOURCE_SUCCEEDED:
            return {
                ...state,
                files: action.files,
                loading: false,
            };

        case reduxActionTypes.GET_FILES_BY_SOURCE_FAILED:
            return {
                ...state,
                loading: false,
            };

        // Add new files
        case reduxActionTypes.ADD_NEW_FILES_PROCESSING:
            return {
                ...state,
                processingAction: true, //adding = true
                savedFiles: false //saved = false
            };

        case reduxActionTypes.ADD_NEW_FILES_SUCCEEDED:
            return {
                ...state,
                // Because add new files api return only new files
                // files: [...state.files, ...action.files],
                files: action.files, // return all files from registration.Attachments
                processingAction: false, //adding = false
                savedFiles: true //saved = true
            };

        case reduxActionTypes.ADD_NEW_FILES_FAILED:
            return {
                ...state,
                processingAction: false, //adding = false
                savedFiles: false //saved = false
            };

        // Update files
        case reduxActionTypes.UPDATE_FILES_PROCESSING:
            return {
                ...state,
                processingAction: true, //updating
                savedFiles: false //!saved
            };
    
        case reduxActionTypes.UPDATE_FILES_SUCCEEDED:
            return {
                ...state,
                files: action.files,
                processingAction: false, //!updating
                savedFiles: true //saved
            };

        case reduxActionTypes.UPDATE_FILES_FAILED:
            return {
                ...state,
                processingAction: false, //!updating
                savedFiles: false //!saved
            };

        // Remove files
        case reduxActionTypes.REMOVE_FILES_PROCESSING:
            return {
                ...state,
                processingAction: true, //removing
                savedFiles: false, //!removed
            };
    
        case reduxActionTypes.REMOVE_FILES_SUCCEEDED:
            return {
                ...state,
                files: action.files,
                processingAction: false, //!removing
                savedFiles: true, //removed
            };

        case reduxActionTypes.REMOVE_FILES_FAILED:
            return {
                ...state,
                processingAction: false, //!removing
                savedFiles: false, //!removed
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/attachment/reducer.ts